// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/Content/ExternalMappingsCount/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_Connection_Content_ExternalMappingsCount($connection_id: uuid!) {
  apps_external_mappings_aggregate(
    where: { connection_id: { _eq: $connection_id } }
  ) {
    aggregate {
      count
    }
  }
}

`